const PROS_INFOGRAFICA_DURATION_MS = 500;

function startProsInfograficaObserve(){
    const container = document.querySelector('#vac .pros-infografica');
    if (!container || container.dataset.observed === 'true') {
        return;
    }

    const images = [...container.querySelectorAll('.pros-infografica__item')];
    if (!images.length) {
        return;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function animateImage(index){
        if (index >= images.length) {
            return;
        }

        const img = images[index];
        img.classList.add('animated');

        if (reducedMotion) {
            animateImage(index + 1);
            return;
        }

        let fallbackId;

        const onTransitionEnd = (event) => {
            if (event.target !== img || event.propertyName !== 'opacity') {
                return;
            }
            img.removeEventListener('transitionend', onTransitionEnd);
            clearTimeout(fallbackId);
            animateImage(index + 1);
        };

        img.addEventListener('transitionend', onTransitionEnd);

        fallbackId = setTimeout(() => {
            img.removeEventListener('transitionend', onTransitionEnd);
            if (index + 1 < images.length && !images[index + 1].classList.contains('animated')) {
                animateImage(index + 1);
            }
        }, PROS_INFOGRAFICA_DURATION_MS + 80);
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting || container.dataset.animated === 'true') {
                return;
            }
            container.dataset.animated = 'true';
            observer.unobserve(container);

            if (reducedMotion) {
                images.forEach((img) => img.classList.add('animated'));
                return;
            }

            animateImage(0);
        });
    }, {
        root: null,
        threshold: 0.25,
    });

    container.dataset.observed = 'true';
    observer.observe(container);
}

export function startAnimationObserve(){
    
    let observer = new IntersectionObserver(onIntersection,{
        root:null,
        threshold:.5
    })

    function onIntersection(entries,opts){
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                entry.target.classList.add('animated')
            }
        });
    }

    document.querySelectorAll('.slideFadeInOnScroll').forEach(el=>{
        if(el)
            observer.observe(el)
    })

    startProsInfograficaObserve();

}